import React, { useEffect, useState, useContext } from "react";
import "./Comments.scss";
import { useTranslation } from "react-i18next";
import { Button } from "react-bootstrap";
import TextareaAutosize from "react-textarea-autosize";
import { Link } from "react-router-dom";
import { PersonCircle } from "react-bootstrap-icons";
import i18n from "i18next";
import axios from "axios";

import { UserContext } from "../../api/user/userContext";
import { Avatars, handSlug, nFormatter, slug } from "../../api/ReplayVariables";

function Comments({ hand, onLogin, onComment }) {
  const { user } = useContext(UserContext);
  const [comment, setComment] = useState("");
  const [ready, setReady] = useState(false);

  function validateForm() {
    return ready && comment.trim().length > 0;
  }

  function handleSubmit(event) {
    event.preventDefault();
    if (user !== null && user.id > 0) {
      setReady(false);
      axios({
        method: "post",
        headers: { "Content-Type": "multipart/form-data" },
        url: window.serverUrl+`/social/comment.php`,
        data: {
          id: hand.id,
          id_slug: slug(hand.user_name),
          my_slug: slug(user.username),
          hand_slug: handSlug(hand),
          lng: i18n.language,
          comment: comment
        }
      })
        //.then((r) => r.json())
        .then((resp) => {
          let data = resp.data;
          if (data.error === 401) {
            onLogin();
          } else if (data.error === 404) {
            setReady(true);
          } else {
            let _comment = comment;
            setComment("");
            onComment({
              id: data.comment,
              user_id: user.id,
              username: user.username,
              avatar: user.avatar,
              date: new Date(),
              comment: _comment
            });
          }
        })
        .catch((err) => {
          console.error("fetch problem", err);
          setReady(true);
        });
    } else {
      onLogin();
    }
  }

  const { t } = useTranslation();

  const letters = [
    "a",
    "z",
    "e",
    "r",
    "t",
    "y",
    "u",
    "i",
    "o",
    "p",
    "q",
    "s",
    "d",
    "f",
    "g",
    "h",
    "j",
    "k",
    "l",
    "m",
    "w",
    "x",
    "c",
    "v",
    "b",
    "n"
  ];

  const getAvatar = (pseudo) => {
    let letter = pseudo.substring(0, 1).toLowerCase();
    if (letters.indexOf(letter) !== -1) {
      return Avatars["avatar" + letter.toUpperCase()];
    } else {
      return Avatars.avatarA;
    }
  };
  useEffect(() => {
    //console.log("comments effects");
    setReady(false);
    let timer = setTimeout(() => {
      setReady(true);
    }, 2000);
    return () => {
      setReady(true);
      clearTimeout(timer);
    };
  }, [user, hand]);

  return (
    <div className="comments d-flex flex-column">
      <div className="add-comment d-flex flex-column">
        <div className="top">
          {nFormatter(hand.nb_comments)}{" "}
          {t("replayApp." + (hand.nb_comments > 1 ? "comments" : "comment"))}
        </div>
        <form onSubmit={handleSubmit} className="add-comment d-flex">
          {user !== null && user.avatar ? (
            <img
              className="avatar-image"
              src={
                window.serverUrl+"/media/kunena/avatars/" + user.avatar
              }
              alt="avatar"
            />
          ) : user !== null && user.username ? (
            <img className="avatar" src={getAvatar(user.username)} alt="" />
          ) : (
            <PersonCircle className="avatar"></PersonCircle>
          )}
          <div className="comment-container d-flex flex-column">
            <TextareaAutosize
              onChange={(evt) => setComment(evt.target.value)}
              value={comment}
              placeholder={t("replayApp.comment_placeholder")}
            ></TextareaAutosize>
            <div className="comment-actions d-flex justify-content-end">
              <Button disabled={!validateForm()} id="cancel-post">
                {t("replayApp.cancel")}
              </Button>
              <Button type="submit" disabled={!validateForm()} id="post">
                {t("replayApp.post_comment")}
              </Button>
            </div>
          </div>
        </form>
      </div>
      <div className="comment-list d-flex flex-column">
        {hand.comments !== null ? (
          hand.comments.map((_comment) => (
            <div
              key={"comment-" + _comment.id}
              className="d-flex comment-container"
            >
              {_comment.avatar ? (
                <img
                  className="avatar-image"
                  src={
                    window.serverUrl+"/media/kunena/avatars/" +
                    _comment.avatar
                  }
                  alt="avatar"
                />
              ) : (
                <img
                  className="avatar"
                  src={
                    Avatars[
                      "avatar" + _comment.username.substring(0, 1).toUpperCase()
                    ]
                  }
                  alt=""
                />
              )}
              <div className="d-flex flex-column">
                <div className="comment-user">
                  <Link
                    to={"/c/" + slug(comment.username) + "-" + _comment.user_id}
                  >
                    {_comment.username}
                  </Link>{" "}
                  <span className="date">
                    {new Intl.DateTimeFormat(i18n.language, {
                      year: "numeric",
                      month: "long",
                      day: "2-digit",
                      hour: "2-digit",
                      minute: "2-digit",
                      second: "2-digit"
                    }).format(new Date(_comment.date))}
                  </span>
                </div>
                <div className="comment">{_comment.comment}</div>
              </div>
            </div>
          ))
        ) : (
          <></>
        )}
      </div>
    </div>
  );
}
export default Comments;
